import { useRef } from 'react';
import { useTheme } from '../hooks/useTheme';
import { MonitorIcon, MoonIcon, SunIcon } from './icons';
import './ThemeSelector.css';

const OPTIONS = [
  { id: 'light', label: 'Clair', Icon: SunIcon },
  { id: 'dark', label: 'Sombre', Icon: MoonIcon },
  { id: 'auto', label: 'Auto', Icon: MonitorIcon, hint: 'Suit le réglage du système' },
];

/**
 * Sélecteur de thème Clair / Sombre / Auto (groupe de boutons radio).
 * Flèches gauche/droite pour changer, un seul arrêt de tabulation.
 */
export function ThemeSelector() {
  const { preference, setPreference } = useTheme();
  const refs = useRef([]);

  const onKeyDown = (event) => {
    const index = OPTIONS.findIndex((o) => o.id === preference);
    let next = null;
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % OPTIONS.length;
    if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + OPTIONS.length) % OPTIONS.length;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = OPTIONS.length - 1;
    if (next == null) return;
    event.preventDefault();
    setPreference(OPTIONS[next].id);
    refs.current[next]?.focus();
  };

  return (
    <div className="theme-selector" role="radiogroup" aria-label="Thème de l'interface" onKeyDown={onKeyDown}>
      {OPTIONS.map(({ id, label, Icon, hint }, i) => {
        const checked = preference === id;
        return (
          <button
            key={id}
            ref={(el) => { refs.current[i] = el; }}
            type="button"
            role="radio"
            aria-checked={checked}
            tabIndex={checked ? 0 : -1}
            className={`theme-selector__option ${checked ? 'is-checked' : ''}`}
            title={hint ? `${label} — ${hint}` : label}
            onClick={() => setPreference(id)}
          >
            <Icon size={15} />
            <span className="theme-selector__label">{label}</span>
          </button>
        );
      })}
    </div>
  );
}
